<article class="flex h-full flex-col overflow-hidden rounded-xl border border-border bg-card shadow-sm">
    <div class="relative aspect-9/16 overflow-hidden border-b border-border bg-black">
        @switch (item().mediaKind) {
        @case ('video') {
        <video class="h-full w-full bg-black object-cover" controls playsinline preload="metadata"
            [src]="item().contentUrls[0]" [attr.aria-label]="alt()"></video>
        }
        @case ('image') {
        <img class="h-full w-full object-cover" [src]="item().contentUrls[0]" [alt]="alt()" />
        }
        @case ('carousel') {
        @for (url of currentSlide(); track url) {
        @if (currentIsVideo()) {
        <video class="h-full w-full bg-black object-cover" controls playsinline preload="metadata" [src]="url"
            [attr.aria-label]="alt()"></video>
        } @else {
        <img class="h-full w-full object-cover" [src]="url" [alt]="alt()" />
        }
        }
        <div class="pointer-events-none absolute inset-0 flex items-center justify-between px-2">
            <button type="button" class="btn-shout-fab-secondary pointer-events-auto bg-card" (click)="previous()"
                aria-label="Previous slide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                    <path d="m15 18-6-6 6-6" />
                </svg>
            </button>
            <button type="button" class="btn-shout-fab-secondary pointer-events-auto bg-card" (click)="next()"
                aria-label="Next slide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                    <path d="m9 18 6-6-6-6" />
                </svg>
            </button>
        </div>
        <p
            class="pointer-events-none absolute left-1/2 top-2 m-0 -translate-x-1/2 rounded-full bg-black/60 px-2 py-0.5 text-xs font-medium text-white">
            {{ slideIndex() + 1 }} / {{ item().contentUrls.length }}
        </p>
        }
        @default {
        <div class="grid h-full place-items-center bg-muted text-muted-foreground">
            <div class="flex flex-col items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true">
                    <path d="M10.41 10.41a2 2 0 1 1-2.83-2.83" />
                    <line x1="13.5" x2="6" y1="13.5" y2="21" />
                    <line x1="18" x2="21" y1="12" y2="15" />
                    <path d="M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59" />
                    <path d="M21 15V5a2 2 0 0 0-2-2H9" />
                    <line x1="2" x2="22" y1="2" y2="22" />
                </svg>
                <p class="m-0 text-xs font-bold uppercase tracking-wide">No preview available</p>
            </div>
        </div>
        }
        }
    </div>
    <footer class="flex flex-col gap-2 px-3 py-2">
        @if (creatorName()) {
        <p class="m-0 truncate text-sm font-semibold text-foreground">{{ creatorName() }}</p>
        }

        <div class="flex items-center justify-between gap-3">
        <div class="flex flex-row items-center justify-start gap-x-2">
            <span
                class="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10 dark:bg-red-400/10 dark:text-red-400 dark:inset-ring-red-400/20">Issues
                <b class="font-bold ml-2">{{ item().issues }}</b></span>

            <span
                class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Approved
                <b class="font-bold ml-2">{{ item().approvedCount }}</b></span>
        </div>

        <scr-screening-details-drawer [content]="item()" [briefId]="briefId()"></scr-screening-details-drawer>
        </div>
    </footer>
</article>